// src/services/urls.js

// ── Active: AWS S3 ─────────────────────────────────────────────────────────────
// const SERVER_CONFIG = {
//     "https://school.trackingacademy.in/backend/public/api": {
//       exportUrl: "https://schooltracking.s3.eu-north-1.amazonaws.com/",
//       reportUrl: "https://school.trackingacademy.in/backend/public/",
//     },
//    "https://bonnenehru.trackingacademy.in/backend/public/api": {
//       exportUrl: "https://schooltracking.s3.eu-north-1.amazonaws.com/",
//       reportUrl: "https://bonnenehru.trackingacademy.in/backend/public/",
//     },
//     "https://kidspark.trackingacademy.in/backend/public/api": {
//       exportUrl: "https://schooltracking.s3.eu-north-1.amazonaws.com/",
//       reportUrl: "https://kidspark.trackingacademy.in/backend/public/",
//     },
//   };

// ── Cloudflare R2 (replace the SERVER_CONFIG above with this block to activate)
const SERVER_CONFIG = {
  "https://school.trackingacademy.in/backend/public/api": {
    exportUrl: "https://pub-26a6d21d158e4065868d4bdaa683f04b.r2.dev/",
    reportUrl: "https://school.trackingacademy.in/backend/public/",
  },
  // "https://bonnenehru.trackingacademy.in/backend/public/api": {
  //   exportUrl: "https://pub-26a6d21d158e4065868d4bdaa683f04b.r2.dev/",
  //   reportUrl: "https://bonnenehru.trackingacademy.in/backend/public/",
  // },
  // "https://kidspark.trackingacademy.in/backend/public/api": {
  //   exportUrl: "https://pub-26a6d21d158e4065868d4bdaa683f04b.r2.dev/",
  //   reportUrl: "https://kidspark.trackingacademy.in/backend/public/",
  // },
  // "https://bestschool.trackingacademy.in/backend/public/api": {
  //   exportUrl: "https://pub-26a6d21d158e4065868d4bdaa683f04b.r2.dev/",
  //   reportUrl: "https://bestschool.trackingacademy.in/backend/public/",
  // },
};
// ──────────────────────────────────────────────────────────────────────────────

  export function getServerUrls() {
    const baseUrl = localStorage.getItem("activeBaseUrl");
  
    return SERVER_CONFIG[baseUrl] || {
      exportUrl: "https://pub-26a6d21d158e4065868d4bdaa683f04b.r2.dev/",
      reportUrl: "https://school.trackingacademy.in/backend/public/",
    };
  }
  